import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DataStoreService } from './data_store/data-store.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(DataStoreService);
  const router = inject(Router);

  // Check if authentication signatures exist in state management storage
  if (authService.getAuth()) {
    return true;
  }

  // Session missing, intercept navigation and bounce user to login checkpoint
  router.navigate(['/login']);
  return false;
};
